import React from "react";

export const IconExpandCollapseArrow = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M1 7.66675L4 11.0001L7 7.66675" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 11L4 1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
